import { ProposalCommandType } from 'graphql/generated'
import {
  getCommandDescription,
  IProposalCommandInputProps
} from './ProposalCommand.types'
import { useEffect } from 'react'

function ChangeEnableNewMembershipRequestsCommand({
  onChange,
  onValidityChange,
  collective
}: IProposalCommandInputProps) {
  useEffect(() => {
    onChange({
      type: ProposalCommandType.CHANGE_ENABLE_NEW_MEMBERSHIP_REQUESTS,
      enableNewMembershipRequests:
        !collective.parameters.enableNewMembershipRequests
    })
    // eslint-disable-next-line
  }, [collective.parameters.enableNewMembershipRequests])

  const isValid = true
  useEffect(() => {
    onValidityChange(isValid)
    // eslint-disable-next-line
  }, [isValid])

  return (
    <div className="flex flex-col w-full">
      <div className="flex pt-4 justify-center items-center">
        <p className="text-gray-700 font-light text-sm">
          {getCommandDescription(
            ProposalCommandType.CHANGE_ENABLE_NEW_MEMBERSHIP_REQUESTS,
            collective
          )}
        </p>
      </div>
    </div>
  )
}

export default ChangeEnableNewMembershipRequestsCommand
